<template>
  <div class="witnessRig white-box">
    <!-- <div class="means-head-tit">
      <p>见证/风险揭示双录</p>
    </div> -->
    
    <h3 class="means-head-tit"> 
      <img src="@img/oldCode/title-icon.png"/>
      <span class="title__txt">
        见证/风险揭示双录
      </span>
      <div class="setup-btns">
        <button @click="showCollectionList()">查看资料收集列表</button>
        <button class="save" @click="anychatSetupClick">设置视频参数</button>
      </div>
    </h3>

    <div class="rigCon">
      <img src="@img/oldCode/witness01.png" />
      <p>点击“见证/风险揭示双录”进行远程视频见证</p>
    </div>
    <div class="common-btns">
      <button class="save" @click="startWitness">见证/风险揭示双录</button>
    </div>
    <collection-list v-if="isShowCollection" :collectionList="collectionListArr" @closeCollect="closeCollectionList"
    ></collection-list>
    <k-dialog
      class="showModal" 
      ref="anychatDialog"
      :options="{
        title:'视频见证录制参数设置/测试',
        center: true,
        width: '24%',
        top: '0',
        destroyOnClose: true,
        isCanClickClose: false,
        onCloseBefore: closeDialog, 
        showClose: true, 
        buttons: [
          { text: '取消', handler: closeDialog },
          { text: '确定', handler: saveAnychatSetUp }
        ]
      }"
    >
       <anychat-setup ref="anychatSetup" />
    </k-dialog>
  </div>
</template>
<script>
import Util from "@/oldCode/commonTools/util";
import collectionList from "./collectionList";
import { getKidmImgContent } from "@/service/image-service";
import oppService from "@/service/opp-service";
import kDialog from "@/components/common/dialog.vue";
import anychatSetup from "./anychatSetup.vue";

export default {
  data () {
    return {
      isShowCollection: false,//资料收集列表
      collectionListArr: [],
      historyImgData : {
      },
    };
  },
  components: {
    collectionList,
    kDialog,
    anychatSetup
  },
  props:["collectionList"],
  computed: {
    apptSn () {
      return this.$store.state.apptSn;
    },
    apptStatus () {
      return this.$store.state.apptStatus;
    },
    userInfo () {
      return this.$storage.getJsonSession(this.$definecfg.USER_INFO);
    },
    B_SNO () {
      return this.$storage.getSession(this.$definecfg.B_SNO);
    },
    openAccType () {
      return this.$store.state.openAcctType;
    },
    BUSI_INFO (){
      return this.$storage.getJsonSession(this.$definecfg.BUSI_INFO);
    },
    BUSI_CODE (){
      return this.$storage.getSession(this.$definecfg.BUSI_CODE);
    },
    CUSTOMER_INFO (){
      return this.$storage.getJsonSession(this.$definecfg.CUSTOMER_INFO);
    }
  },
  async created () {
    let browser = Util.getOSAndBrowser();
    if (browser.indexOf("Chrome") !== -1) {
      let info = browser.split("/")[1].replace("Chrome", "");
      this.browserNum = parseInt(info);
    } else {
      this.alert("请使用高版本谷歌浏览器！");
    }
    if(this.BUSI_INFO && this.BUSI_INFO.BIZ_DATA && this.BUSI_INFO.BIZ_DATA.ACCT_PWD_INFO && !this.BUSI_INFO.BIZ_DATA.ACCT_PWD_INFO.TRD_PWD){
      this.alert("密码不能为空，请返回修改保存密码后再进行见证/风险揭示双录");
      return;
    }
    // 如果是预审通过状态就更新为见证中状态
    if(this.apptStatus == "4"){
      await oppService.updateApptStatus(this.$store.state.apptSn,"8");
    }
  },
  mounted (){
    let that = this;
    that.collectionListArr = that.collectionList;
    //获取影像系统，是否做过了见证视频双录
    Promise.all([
      getKidmImgContent({
        B_SNO: that.B_SNO,
        IMG_CLS: "X33",
        ID_CODE: _.get(that.BUSI_INFO,"BIZ_DATA.KEY_INFO.NEW_ID_CODE",""),
      })
    ]).then(res=>{
      that.historyImgData["X33"] = res[0] || {};
    });
  },
  methods: {
    startWitness () {
      let that = this;
      if (!Util.global.IS_CHROME) {
        this.alert("当前浏览器不支持录像操作，请使用谷歌浏览器！");
        return;
      }
      if (this.browserNum < 90) {
        this.alert("系统检测到您当前浏览器版本过低，请升级至90及以上版本！");
        return;
      }
      if (this.apptStatus < 4 || this.apptStatus == 11 || this.apptStatus == 13 || this.apptStatus == 14 || this.apptStatus == 15 || this.apptStatus == 17 || this.apptStatus == 18) {
        this.alert("当前状态不允许进行视频见证操作！");
        return;
      }
      if (this.apptStatus < 4) {
        this.alert("当前状态不允许进行风险揭示操作！");
        return;
      }
      if (this.apptStatus == 11) {
        this.alert("当前流水正在审核中，不允许进行视频见证操作！");
        return;
      }
      if (this.apptStatus == 13) {
        this.alert("当前流水已办理完成，不允许进行视频见证操作！");
        return;
      }
      if (this.apptStatus == 14) {
        this.alert("当前流水已作废，不允许进行视频见证操作！");
        return;
      }
      if (this.apptStatus == 15) {
        this.alert("当前流水处于挂起状态，不允许进行视频见证操作！");
        return;
      }
      if (this.apptStatus == 17) {
        this.alert("当前流水处于已转移VTM状态，不允许进行视频见证操作！");
        return;
      }
      if (this.apptStatus == 18) {
        this.alert("当前流水处于已转移一站通状态，不允许进行视频见证操作！");
        return;
      }
      if(!this.$store.state.permission.witnessAuth){
        this.alert("您无权操作，请先申请权限");
        return false;
      }
      //检查是否已经做过双录
      if (!_.isEmpty( that.historyImgData["X33"])) {
        that.alert({
          messageText: "已做过见证/风险揭示双录，请确认是否重新录制?",
          cancelButtonText: "取消",
          confirmButtonText: "确认",
          confirmedAction: function () {
            that.$emit("changeStep", {type:"lineUp"});
          },
          canceledAction: function () {
          }
        });
        return;
      }
      this.$emit("changeStep", {type:"lineUp"});
    },
    showCollectionList (){
      this.isShowCollection = true;
    },
    closeCollectionList (){
      this.isShowCollection = false;
    },
    saveAnychatSetUp (){
      this.$emit("saveAnychatParam",{
        microphone: this.$refs.anychatSetup.microphone,
        camera: this.$refs.anychatSetup.camera,
        isOpenMode: (this.$refs.anychatSetup.isOpenMode && this.$refs.anychatSetup.isOpenMode.key == "1") || false
      });
      this.$refs.anychatSetup.releaseAnychatSource();
    },
    closeDialog (){
      this.$refs.anychatDialog.close();
      this.$refs.anychatSetup.releaseAnychatSource();
    },
    anychatSetupClick (){
      this.$refs.anychatDialog.open();
      this.$refs.anychatSetup && this.$refs.anychatSetup.initAnyachat();
    }
  }
};
</script>
<style lang="less"  scoped>
@import "~@/styles/less/variable.less";

.witnessRig {
  position: relative;
  .rigCon {
    display: flex;
    align-items: center;
    flex-direction: column;
    // font-size: 0.22rem;
    color: #333333;
    .fontsize-text-medium();
    img {
      margin-top: 1.6rem;
      margin-bottom: 0.46rem;
      width: 6.09rem;
    }
  }
  .common-btns {
    padding: 0;
    .save {
      margin-top: 0.8rem;
      margin-bottom: 1.2rem;
      .fontsize-btn-medium();
      height: 40px;
    }
  }

  .setup-btns {
    position: absolute;
    right: 0;
    display: flex;
    align-items: center;
    button {
      position: relative;
      height: 32px;
      right: 0;
      color: white;
      background: #e5c48a;
      width: auto;
      padding: 0 8px;
      border: .5px solid #E5C48A;
      border-radius: 5px;
      display: inline-block;
      cursor: pointer;
      margin: 0 .08rem;
      .fontsize-btn-medium();
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/imageNode/child/startWitness.vue